module.exports = __webpack_public_path__ + "static/media/Madvillain - Curls - Madvillainy (Full Album).50066bad.mp3";